import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { logout } from "./store/authSlice";

const AuthHandler = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("authToken");

    if (!token) {
      return;
    }

    try {
      const decodedToken = jwtDecode(token);

      if (decodedToken.exp * 1000 < Date.now()) {
        dispatch(logout());
        Cookies.remove("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.error("Invalid token:", error);
      dispatch(logout());
      Cookies.remove("authToken"); 
      navigate("/login");
    }

  }, [dispatch, navigate]);

  return children; 
};

export default AuthHandler;
